function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createStore } from "redux";
import { getCookie, setCookie, deleteCookie, getCookiePath } from "../util/dom";
import { deepClone } from "../util/object";
import { cleanNonLatinExtended } from "../util/string";
import render from "./render";
import { getBeforeDiscountTotal, includeBundleDiscount, splitBundles } from "../components/bundles";
var newsletterDefault = window.sitewide.newsletterDefault;
var defaultState = localStorage.getItem("state") && window.location.hash !== "#reset-application-state" ? JSON.parse(localStorage.getItem("state")) : {
  productCache: {},
  quickShop: {},
  productListItems: {},
  items: {},
  email: {},
  countries: {},
  geCountries: {},
  pricelist: {},
  checkoutLogin: false,
  accountEntry: 'login',
  useShippingAddress: false,
  initiatedScript: false,
  productListCompact: false,
  vouchers: {
    currentValue: "",
    error: false
  },
  formErrors: {},
  payment: {
    address: {
      newsletter: newsletterDefault
    },
    shippingAddress: {},
    paymentFailedPage: "",
    paymentReturnPage: "",
    loggedIn: false,
    voyadoId: '',
    createAccount: false,
    termsAndConditions: true,
    dutyConsent: false
  },
  adyenInitiated: false,
  adyenUpdating: false,
  klarnaLoaded: false,
  klarnaUnloaded: false,
  defaultPaymentInitiated: false,
  paymentReturn: {},
  addToBagError: false,
  selectionErrors: {},
  selectionFailed: false,
  account: {},
  store: {},
  favourites: [],
  selection: {}
};
defaultState.store = getCookie("esc_store", true) || {};
if (localStorage.getItem("paymentInfo")) {
  defaultState.payment = JSON.parse(localStorage.getItem("paymentInfo"));
  defaultState.payment.createAccount = false;
} else {
  defaultState.payment = {
    address: {
      newsletter: newsletterDefault
    },
    shippingAddress: {},
    paymentFailedPage: "",
    paymentReturnPage: "",
    loggedIn: false,
    voyadoId: '',
    createAccount: false,
    termsAndConditions: true,
    dutyConsent: false
  };
}
var savePaymentInfo = function savePaymentInfo(paymentInfo, useShippingAddress) {
  if (typeof localStorage !== "undefined") {
    // Remove sensitive and duplicate data
    var tempPaymentInfo = deepClone(paymentInfo);
    delete tempPaymentInfo.address.emailOld;
    delete tempPaymentInfo.address.emailNew;
    delete tempPaymentInfo.address.emailRepeat;
    delete tempPaymentInfo.address.emailNewRepeat;
    delete tempPaymentInfo.address.password;
    delete tempPaymentInfo.address.passwordNew;
    delete tempPaymentInfo.address.passwordRepeat;
    delete tempPaymentInfo.address.passwordNewRepeat;
    delete tempPaymentInfo.address.passwordOld;
    tempPaymentInfo.createAccount = false;
    if (useShippingAddress === false) {
      Object.keys(tempPaymentInfo.address).forEach(function (id) {
        if (tempPaymentInfo.shippingAddress[id]) {
          tempPaymentInfo.address[id] = tempPaymentInfo.shippingAddress[id];
        }
      });
    }
    localStorage.setItem("paymentInfo", JSON.stringify(tempPaymentInfo));
  }
};
var updateCheckoutFieldErrors = function updateCheckoutFieldErrors(state, action) {
  var createAccount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (action.group) {
    var field = {
      visible: 1,
      required: 1
    };
    if (state.paymentFields && state.paymentFields.hasOwnProperty(action.group) && state.paymentFields[action.group][action.id]) {
      field = state.paymentFields[action.group][action.id];
    }
    if (action.id === "password" || action.id === "passwordRepeat") {
      if (createAccount) {
        field.required = true;
        field.visible = true;
      } else {
        field.required = false;
        field.visible = false;
      }
    }
    if (action.id === "state") field.required = true;
    return _objectSpread(_objectSpread({}, state), {}, {
      paymentFields: _objectSpread(_objectSpread({}, state.paymentFields), {}, _defineProperty({}, action.group, _objectSpread(_objectSpread({}, state.paymentFields[action.group]), {}, _defineProperty({}, action.id, _objectSpread(_objectSpread({}, field), {}, {
        error: field.visible && field.required ? action.error : false
      })))))
    });
  }
  if (state.paymentFields[action.id]) {
    var singleField = state.paymentFields[action.id];
    return _objectSpread(_objectSpread({}, state), {}, {
      paymentFields: _objectSpread(_objectSpread({}, state.paymentFields), {}, _defineProperty({}, action.id, _objectSpread(_objectSpread({}, state.paymentFields[action.id]), {}, {
        error: singleField.visible && singleField.required ? action.error : false
      })))
    });
  }
  return _objectSpread({}, state);
};
var formatBundleData = function formatBundleData(item) {
  if ("bundle" in item === false) return false;
  return item.bundle.map(function (bundleItem) {
    return {
      id: "p".concat(bundleItem === null || bundleItem === void 0 ? void 0 : bundleItem.silkProduct, "-v").concat(bundleItem === null || bundleItem === void 0 ? void 0 : bundleItem.silkVariant),
      item: bundleItem.item,
      product: bundleItem.product,
      size: bundleItem.size,
      name: bundleItem.productName,
      sku: bundleItem.sku,
      priceEachAsNumber: bundleItem.priceEachAsNumber,
      priceEachWithoutTaxAsNumber: bundleItem.priceEachWithoutTaxAsNumber,
      brand: bundleItem.brand,
      category: bundleItem.category,
      variant: bundleItem.variant,
      quantity: bundleItem.quantity
    };
  });
};
var shop = function shop() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  console.log('in store');
  var useShippingAddressState = state.useShippingAddress || false;
  switch (action.type) {
    case "UPDATE_PRODUCT_CACHE":
      return _objectSpread(_objectSpread({}, state), {}, {
        productCache: {
          updated: Date.now(),
          items: deepClone(action.cache.products)
        }
      });
    case "UPDATE_CATEGORY_CACHE":
      return _objectSpread(_objectSpread({}, state), {}, {
        categoryCache: {
          updated: Date.now(),
          items: deepClone(action.cache.categories)
        }
      });
    case "UPDATE_BUNDLES_CACHE":
      return _objectSpread(_objectSpread({}, state), {}, {
        bundleCache: {
          updated: Date.now(),
          items: deepClone(action.cache.bundles)
        }
      });
    case "UPDATE_PRICELIST":
      {
        var pricelist = action.cache.pricelist || {};
        return _objectSpread(_objectSpread({}, state), {}, {
          pricelist: pricelist.currency || {}
        });
      }
    case "QUICK_SHOP":
      return _objectSpread(_objectSpread({}, state), {}, {
        quickShop: _objectSpread(_objectSpread({}, state.quickShop), {}, _defineProperty({}, action.productID, deepClone(action.product)))
      });
    case "UPDATE_PRODUCT_LIST_ITEM":
      return _objectSpread(_objectSpread({}, state), {}, {
        productListItems: _objectSpread(_objectSpread({}, state.productListItems), {}, _defineProperty({}, action.productID, deepClone(action.product)))
      });
    case "PRODUCT_LIST_DENSITY":
      return _objectSpread(_objectSpread({}, state), {}, {
        productListCompact: !state.productListCompact
      });
    case "UPDATE_COUNTRIES":
      return _objectSpread(_objectSpread({}, state), {}, {
        countries: _objectSpread({}, deepClone(action.countries))
      });
    case "UPDATE_GE_COUNTRIES":
      return _objectSpread(_objectSpread({}, state), {}, {
        geCountries: _objectSpread({}, deepClone(action.geCountries))
      });
    case "UPDATE_ESC_STORE":
      {
        var _store = _objectSpread(_objectSpread({}, state.store), {}, {
          country: action.country.country || state.store.country,
          state: action.state || state.store.state,
          currency: action.country.currency || state.store.currency,
          market: action.country.market || state.store.market,
          pricelist: action.country.pricelist || state.store.pricelist,
          token: action.country.token || state.store.token
        });

        // set token
        // token: action.data.token

        // setCookie("esc_store", store, 365, 'SameSite=None; Secure');
        setCookie("esc_store", _store, 365, getCookiePath());
        setCookie("country", _store.country.toUpperCase(), 365);
        return _objectSpread(_objectSpread({}, state), {}, {
          store: _store
        });
      }
    case "SUBSCRIBED":
      return _objectSpread(_objectSpread({}, state), {}, {
        email: action.email
      });
    case "SELECT_SIZE":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionErrors: {},
        addToBagError: false,
        items: _objectSpread(_objectSpread({}, state.items), {}, _defineProperty({}, action.product, _objectSpread(_objectSpread({}, state.items[action.product]), {}, {
          size: action.item,
          quantity: action.quantity
        })))
      });
    case "ADD_TO_BAG_ERROR":
      return _objectSpread(_objectSpread({}, state), {}, {
        addToBagError: true
      });
    case "INITIATE_SELECTION":
      return _objectSpread(_objectSpread({}, state), {}, {
        paymentReturn: _objectSpread(_objectSpread({}, state.paymentReturn), {}, {
          paymentHTML: action.data.formHtml
        })
      });
    case "TOGGLE_GIFT_WRAP":
      {
        var paymentInfo = _objectSpread(_objectSpread({}, state.payment), {}, {
          additionalNotes: state.payment.additionalNotes ? '' : 'GIFT WRAP:\n'
        });
        savePaymentInfo(paymentInfo, useShippingAddressState);
        return _objectSpread(_objectSpread({}, state), {}, {
          payment: paymentInfo
        });
      }
    case "UPDATE_SELECTION":
      {
        var _store2 = _objectSpread(_objectSpread({}, state.store), {}, {
          token: action.data.token
        });
        var paymentReturn = _objectSpread({}, state.paymentReturn);
        var shipwallet = _objectSpread({}, state.shipwallet);
        if (action.data.selection && action.data.selection.centraCheckoutScript) {
          paymentReturn.centraCheckoutScript = action.data.selection.centraCheckoutScript;
        }
        var pluginFields = action.data.selection ? action.data.selection.pluginFields : {};
        if (pluginFields && pluginFields.shipwallet) {
          shipwallet.snippet = action.data.selection.pluginFields.shipwallet.snippet || '';
          shipwallet.sessionId = action.data.selection.pluginFields.shipwallet.session_id || '';
        }

        // setCookie("esc_store", store, 365, 'SameSite=None; Secure');
        setCookie("esc_store", _store2, 365, getCookiePath());

        // Why does it update if there is no selection ?
        if (!action.data.selection) return _objectSpread({}, state);
        action.data.selection.items = splitBundles(action.data.selection.items, state.productCache);
        var _getBeforeDiscountTot = getBeforeDiscountTotal(action.data.selection),
          _getBeforeDiscountTot2 = _slicedToArray(_getBeforeDiscountTot, 2),
          beforeDiscountItemTotalAsNumber = _getBeforeDiscountTot2[0],
          beforeDiscountItemTotal = _getBeforeDiscountTot2[1];
        action.data.selection.totals.itemsTotalPrice = beforeDiscountItemTotal;
        action.data.selection.totals.itemsTotalPriceAsNumber = beforeDiscountItemTotalAsNumber;
        var _includeBundleDiscoun = includeBundleDiscount(action.data.selection),
          _includeBundleDiscoun2 = _slicedToArray(_includeBundleDiscoun, 2),
          totalDiscountPriceAsNumber = _includeBundleDiscoun2[0],
          totalDiscountPrice = _includeBundleDiscoun2[1];
        action.data.selection.totals.totalDiscountPrice = totalDiscountPrice;
        action.data.selection.totals.totalDiscountPriceAsNumber = totalDiscountPriceAsNumber;
        return _objectSpread(_objectSpread({}, state), {}, {
          selectionErrors: {},
          addToBagError: false,
          store: _store2,
          paymentReturn: paymentReturn,
          shipwallet: shipwallet,
          payment: _objectSpread(_objectSpread({}, state.payment), {}, {
            loggedIn: !!action.data.loggedIn,
            voyadoId: action.data.loggedIn && action.data.loggedIn.voyado_customer_id || state.payment.voyadoId
          }),
          selection: {
            // Replace all data every time.
            currency: action.data.selection.currency,
            paymentMethod: action.data.selection.paymentMethod,
            shippingMethod: action.data.selection.shippingMethod,
            items: action.data.selection.items.map(function (item) {
              return {
                item: item.item,
                size: item.size,
                name: item.product.name,
                id: "p".concat(item.product.centraProduct, "-v").concat(item.product.centraVariant),
                // Match google merchant feed.
                sku: item.product.productSku,
                brand: item.product.brandName,
                variant: item.product.variantName,
                category: item.product.categoryUri,
                quantity: item.quantity,
                line: item.line,
                priceEach: item.priceEach,
                priceEachAsNumber: item.priceEachAsNumber,
                totalPrice: item.totalPrice,
                totalPriceAsNumber: item.totalPriceAsNumber,
                priceEachBeforeDiscount: item.priceEachBeforeDiscount,
                priceEachBeforeDiscountAsNumber: item.priceEachBeforeDiscountAsNumber,
                anyDiscount: item.anyDiscount,
                taxPercent: item.taxPercent,
                priceEachWithoutTax: item.priceEachWithoutTax,
                priceEachWithoutTaxAsNumber: item.priceEachWithoutTaxAsNumber,
                priceEachReduction: item.priceEachReduction,
                priceEachReductionAsNumber: item.priceEachReductionAsNumber,
                bundle: formatBundleData(item),
                product: item.product.product
              };
            }),
            discounts: deepClone(action.data.selection.discounts),
            totals: _objectSpread({}, action.data.selection.totals),
            paymentMethods: action.data.paymentMethods.map(function (method) {
              return _objectSpread({}, method);
            }),
            shippingMethods: action.data.shippingMethods.map(function (method) {
              return _objectSpread({}, method);
            }),
            paymentFields: deepClone(action.data.paymentFields)
          }
        });
      }
    case "INIT_PAYMENT_INFO":
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          payment: action.paymentInfo
        });
      }
    case "SET_DEFAULT_PAYMENT_METHOD":
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          defaultPaymentInitiated: action.hasOwnProperty('status') ? action.status : true
        });
      }
    case "KLARNA_UNLOADED":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionErrors: {},
        klarnaUnloaded: true
      });
    case "KLARNA_LOADED":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionErrors: {},
        klarnaLoaded: true
      });
    case 'ADYEN_INITIATED':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectionErrors: {},
          adyenInitiated: true
        });
      }
    case 'ADYEN_UPDATING':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectionErrors: {},
          adyenUpdating: action.isUpdating
        });
      }
    case "UPDATE_ADDRESS":
      {
        if (!action.id) return state;
        var value = cleanNonLatinExtended(action.value);
        var _paymentInfo = action.group ? _objectSpread(_objectSpread({}, state.payment), {}, _defineProperty({}, action.group, _objectSpread(_objectSpread({}, state.payment[action.group]), {}, _defineProperty({}, action.id, value)))) : _objectSpread(_objectSpread({}, state.payment), {}, _defineProperty({}, action.id, value));
        savePaymentInfo(_paymentInfo, useShippingAddressState);
        return _objectSpread(_objectSpread({}, state), {}, {
          formErrors: {},
          selectionErrors: {},
          payment: _paymentInfo,
          selection: _objectSpread(_objectSpread({}, state.selection), updateCheckoutFieldErrors(state.selection, action, _paymentInfo.createAccount))
        });
      }
    case "FORM_ERRORS":
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          formErrors: _objectSpread(_objectSpread({}, state.formErrors), deepClone(action.errors))
        });
      }
    case "UPDATE_ERRORS":
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selection: _objectSpread(_objectSpread({}, state.selection), updateCheckoutFieldErrors(state.selection, action, state.payment.createAccount))
        });
      }
    case "ACCOUNT_FORGOT_SENT":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionSuccess: {
          forgotPasswordSuccess: true
        }
      });
    case "ACCOUNT_FORGOT_FAILED":
      delete state.selectionSuccess;
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionErrors: _objectSpread(_objectSpread({}, state.selectionErrors), {}, {
          forgotPasswordError: action.hasError
        })
      });
    case "ACCOUNT_ENTRY_FAILED":
    case "SELECTION_ERROR":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionErrors: _objectSpread(_objectSpread({}, state.selectionErrors), {}, {
          selectionError: action.hasError
        })
      });
    case "SELECTION_ERROR_STOCK":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionErrors: _objectSpread(_objectSpread({}, state.selectionErrors), {}, {
          selectionErrorStock: action.hasError
        })
      });
    case "SELECTION_ERROR_PAYMENT":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionErrors: _objectSpread(_objectSpread({}, state.selectionErrors), {}, {
          selectionErrorPayment: action.hasError
        })
      });
    case "SELECTION_FAILED":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionFailed: action.hasError
      });
    case "SELECTION_ERROR_REGISTERED":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionErrors: _objectSpread(_objectSpread({}, state.selectionErrors), {}, {
          selectionErrorRegistered: action.hasError
        })
      });
    case "SELECTION_ERROR_PASSWORD":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionErrors: _objectSpread(_objectSpread({}, state.selectionErrors), {}, {
          selectionErrorPassword: action.hasError
        })
      });
    case "SELECTION_ERROR_DUTY_CONSENT":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionErrors: _objectSpread(_objectSpread({}, state.selectionErrors), {}, {
          selectionErrorDutyConsent: action.hasError
        })
      });
    case "BOOLEAN_CHANGE":
      {
        var _paymentInfo2;
        if (action.id === "useShipping") {
          var _paymentInfo3 = _objectSpread(_objectSpread({}, state.payment), {}, {
            shippingAddress: _objectSpread(_objectSpread({}, state.payment.shippingAddress), {}, {
              email: state.payment.shippingAddress.email || state.payment.address.email,
              firstName: state.payment.shippingAddress.firstName || state.payment.address.firstName,
              lastName: state.payment.shippingAddress.lastName || state.payment.address.lastName,
              company: state.payment.shippingAddress.company || state.payment.address.company,
              phoneNumber: state.payment.shippingAddress.phoneNumber || state.payment.address.phoneNumber,
              address1: state.payment.shippingAddress.address1 || state.payment.address.address1,
              address2: state.payment.shippingAddress.address2 || state.payment.address.address2,
              zipCode: state.payment.shippingAddress.zipCode || state.payment.address.zipCode,
              city: state.payment.shippingAddress.city || state.payment.address.city,
              country: state.payment.shippingAddress.country || state.payment.address.country
            })
          });
          savePaymentInfo(_paymentInfo3, !state.useShippingAddress);
          return _objectSpread(_objectSpread({}, state), {}, {
            selectionErrors: {},
            useShippingAddress: !state.useShippingAddress,
            payment: _paymentInfo3
          });
        }
        if (action.id === "subscribeToNewsletter") {
          return _objectSpread(_objectSpread({}, state), {}, {
            selectionErrors: {},
            payment: _objectSpread(_objectSpread({}, state.payment), {}, {
              address: _objectSpread(_objectSpread({}, state.payment.address), {}, {
                newsletter: !state.payment.address.newsletter
              })
            })
          });
        }
        _paymentInfo2 = _objectSpread(_objectSpread({}, state.payment), {}, _defineProperty({}, action.id, !state.payment[action.id]));
        savePaymentInfo(_paymentInfo2, useShippingAddressState);
        return _objectSpread(_objectSpread({}, state), {}, {
          selectionErrors: {},
          payment: _paymentInfo2
        });
      }
    case "VOUCHER_INPUT":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionErrors: {},
        vouchers: _objectSpread(_objectSpread({}, state.vouchers), {}, {
          currentValue: action.value,
          error: false
        })
      });
    case "VOUCHER_ERROR":
      return _objectSpread(_objectSpread({}, state), {}, {
        vouchers: _objectSpread(_objectSpread({}, state.vouchers), {}, {
          error: !state.vouchers.error
        })
      });
    case "PAYMENT_RETURN":
      if (window.CentraCheckout) window.CentraCheckout.resume();
      if (!action.data) {
        return _objectSpread(_objectSpread({}, state), {}, {
          paymentReturn: {}
        });
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        paymentReturn: {
          paymentHTML: action.data.selection.paymentHTML,
          centraCheckoutScript: action.data.selection.centraCheckoutScript
        }
      });
    case "INITIATED_SCRIPT":
      return _objectSpread(_objectSpread({}, state), {}, {
        initiatedScript: true
      });
    case "RECEIPT_DATA":
      {
        var receiptSnippet = "";
        if (action.data.order.paymentMethodData && action.data.order.paymentMethodData.snippet) {
          receiptSnippet = action.data.order.paymentMethodData.snippet;
        }
        action.data.order.items = splitBundles(action.data.order.items, state.productCache);
        var _getBeforeDiscountTot3 = getBeforeDiscountTotal(action.data.order),
          _getBeforeDiscountTot4 = _slicedToArray(_getBeforeDiscountTot3, 2),
          _beforeDiscountItemTotalAsNumber = _getBeforeDiscountTot4[0],
          _beforeDiscountItemTotal = _getBeforeDiscountTot4[1];
        action.data.order.totals.itemsTotalPrice = _beforeDiscountItemTotal;
        action.data.order.totals.itemsTotalPriceAsNumber = _beforeDiscountItemTotalAsNumber;
        var _includeBundleDiscoun3 = includeBundleDiscount(action.data.order),
          _includeBundleDiscoun4 = _slicedToArray(_includeBundleDiscoun3, 2),
          _totalDiscountPriceAsNumber = _includeBundleDiscoun4[0],
          _totalDiscountPrice = _includeBundleDiscoun4[1];
        action.data.order.totals.totalDiscountPrice = _totalDiscountPrice;
        action.data.order.totals.totalDiscountPriceAsNumber = _totalDiscountPriceAsNumber;
        return _objectSpread(_objectSpread({}, state), {}, {
          store: _objectSpread(_objectSpread({}, state.store), {}, {
            token: action.data.token
          }),
          payment: _objectSpread(_objectSpread({}, state.payment), {}, {
            loggedIn: !!action.data.loggedIn,
            voyadoId: action.data.loggedIn && action.data.loggedIn.voyado_customer_id || state.payment.voyadoId
          }),
          selection: {
            // Replace all data every time.
            order: action.data.order.order,
            currency: action.data.order.currency,
            date: action.data.order.date,
            items: action.data.order.items.map(function (item) {
              return {
                item: item.item,
                size: item.size,
                name: item.product.name,
                id: "p".concat(item.product.centraProduct, "-v").concat(item.product.centraVariant),
                sku: item.product.productSku,
                brand: item.product.brandName,
                variant: item.product.variantName,
                category: item.product.categoryUri,
                quantity: item.quantity,
                line: item.line,
                priceEach: item.priceEach,
                priceEachAsNumber: item.priceEachAsNumber,
                totalPrice: item.totalPrice,
                totalPriceAsNumber: item.totalPriceAsNumber,
                priceEachBeforeDiscount: item.priceEachBeforeDiscount,
                priceEachBeforeDiscountAsNumber: item.priceEachBeforeDiscountAsNumber,
                anyDiscount: item.anyDiscount,
                taxPercent: item.taxPercent,
                priceEachWithoutTax: item.priceEachWithoutTax,
                priceEachWithoutTaxAsNumber: item.priceEachWithoutTaxAsNumber,
                priceEachReduction: item.priceEachReduction,
                priceEachReductionAsNumber: item.priceEachReductionAsNumber,
                bundle: formatBundleData(item),
                product: item.product.product
              };
            }),
            discounts: deepClone(action.data.order.discounts),
            totals: _objectSpread({}, action.data.order.totals),
            address: _objectSpread({}, action.data.order.address),
            shippingAddress: _objectSpread({}, action.data.order.shippingAddress),
            paymentMethodName: action.data.order.paymentMethodName,
            shippingMethodName: action.data.order.shippingMethodName,
            shipwalletMethod: action.data.order.attributes.shipwallet_method.data || '',
            receiptSnippet: receiptSnippet
          }
        });
      }
    case "RECEIPT_ERROR":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionErrors: _objectSpread(_objectSpread({}, state.selectionErrors), {}, {
          selectionError: action.reason
        })
      });
    case "DESTROY_SELECTION":
      {
        deleteCookie('receiptRendered');
        // setCookie("esc_store", {
        //   ...state.store,
        //   token: ''
        // }, 365, 'SameSite=None; Secure');
        setCookie("esc_store", _objectSpread(_objectSpread({}, state.store), {}, {
          token: ''
        }), 365, getCookiePath());
        console.log('token reset');
        return _objectSpread(_objectSpread({}, state), {}, {
          items: {},
          store: _objectSpread(_objectSpread({}, state.store), {}, {
            token: ''
          }),
          useShippingAddress: false,
          vouchers: {
            currentValue: "",
            error: false
          },
          payment: _objectSpread(_objectSpread({}, state.payment), {}, {
            termsAndConditions: true,
            dutyConsent: false,
            createAccount: false,
            additionalNotes: ''
          }),
          paymentReturn: {},
          addToBagError: false,
          selectionErrors: {},
          selection: {}
        });
      }
    case "TOGGLE_LOGIN":
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          checkoutLogin: !state.checkoutLogin
        });
      }
    case "TOGGLE_ACCOUNT_ENTRY":
      {
        var accountEntry = 'login';
        if (state.accountEntry === 'register' && action.state === 'registerLogin') accountEntry = 'login';else if (state.accountEntry === 'login' && action.state === 'registerLogin') accountEntry = 'register';else if (state.accountEntry === 'forgot' && action.state === 'loginForgot') accountEntry = 'login';else if (state.accountEntry === 'login' && action.state === 'loginForgot') accountEntry = 'forgot';else accountEntry = action.state;
        delete state.selectionSuccess;
        return _objectSpread(_objectSpread({}, state), {}, {
          selectionErrors: {},
          formErrors: {},
          accountEntry: accountEntry
        });
      }
    case "UPDATE_ACCOUNT":
      {
        var _paymentInfo4 = _objectSpread(_objectSpread({}, state.payment), {}, {
          loggedIn: true,
          createAccount: false,
          address: _objectSpread(_objectSpread({}, state.payment.address), {}, {
            newsletter: action.data.loggedIn.newsletter || state.payment.address.newsletter,
            email: action.data.loggedIn.email || state.payment.address.email,
            firstName: action.data.loggedIn.firstName || state.payment.address.firstName,
            lastName: action.data.loggedIn.lastName || state.payment.address.lastName,
            company: action.data.loggedIn.company || state.payment.address.company,
            phoneNumber: action.data.loggedIn.phoneNumber || state.payment.address.phoneNumber,
            address1: action.data.loggedIn.address1 || state.payment.address.address1,
            address2: action.data.loggedIn.address2 || state.payment.address.address2,
            zipCode: action.data.loggedIn.zipCode || state.payment.address.zipCode,
            city: action.data.loggedIn.city || state.payment.address.city,
            state: action.data.loggedIn.state || state.payment.address.state,
            country: action.data.loggedIn.country || state.payment.address.country,
            emailOld: '',
            emailNew: '',
            emailRepeat: '',
            emailNewRepeat: '',
            password: '',
            passwordNew: '',
            passwordRepeat: '',
            passwordNewRepeat: '',
            passwordOld: ''
          })
        });
        savePaymentInfo(_paymentInfo4, useShippingAddressState);
        return _objectSpread(_objectSpread({}, state), {}, {
          payment: _paymentInfo4
        });
      }
    case "ACCOUNT_ORDERS":
      {
        var orders = [].concat(_toConsumableArray(state.account.orders || []), _toConsumableArray(deepClone(action.data.orders))).reduce(function (acc, o) {
          if (acc.length === 0) return [o];
          // Order doesn't exist in array add.
          if (acc.filter(function (fo) {
            return fo.order === o.order;
          }).length === 0) return [].concat(_toConsumableArray(acc), [o]);
          // Order exists in array skip.
          return acc;
        }, []);
        return _objectSpread(_objectSpread({}, state), {}, {
          account: _objectSpread(_objectSpread({}, state.account), {}, {
            orders: orders,
            hasMoreOrders: action.data.ordersPaging.totalSize > orders.length
          })
        });
      }
    case "ACCOUNT_LOGOUT":
      {
        var _paymentInfo5 = _objectSpread(_objectSpread({}, state.payment), {}, {
          loggedIn: false,
          voyadoId: ''
        });
        savePaymentInfo(_paymentInfo5, useShippingAddressState);
        return _objectSpread(_objectSpread({}, state), {}, {
          payment: _paymentInfo5,
          account: {}
        });
      }
    default:
      return state;
  }
};
var store = createStore(shop);
store.subscribe(function () {
  render();

  /*
    Avoid saving quickShop to localstorage so we don't need to
    worry about clearing it's cache.
  */
  var saveState = deepClone(store.getState(), ["quickShop", "account", "formErrors", "payment"]);

  // Don't save following state.
  saveState.quickShop = {};
  saveState.account = {};
  saveState.formErrors = {};
  saveState.checkoutLogin = false;
  saveState.adyenInitiated = false;
  saveState.adyenUpdating = false;
  saveState.klarnaLoaded = false;
  saveState.klarnaUnloaded = false;
  saveState.vouchers.currentValue = '';
  saveState.vouchers.error = false;
  localStorage.setItem("state", JSON.stringify(saveState).replace(/</g, "\\u003c"));
});
export default store;

// client clicks button -> we set up an action that listens to that -> we update and save the object -> we then render the changes.
// uni-directional flow.


// WEBPACK FOOTER //
// ./scripts/shop/store.js